export var INavigationLink;
(function (INavigationLink) {
    let NavigationType;
    (function (NavigationType) {
        /**
         * for some special nodes in the tree that don't navigate to anywhere
         */
        NavigationType["NONE"] = "NONE";
        /**
         * navigate to a product result page
         */
        NavigationType["PRODUCT"] = "PRODUCT";
        /**
         * navigate to a brand result page
         */
        NavigationType["BRAND"] = "BRAND";
        /**
         * navigate to a sub link list page (C2/C3 page on mobile)
         */
        NavigationType["SUBLINK_LIST"] = "SUBLINK_LIST";
        /**
         * expand the sub link list instead of navigating to a new page
         */
        NavigationType["SUBLINK_EXPANDED_LIST"] = "SUBLINK_EXPANDED_LIST";
        /**
         * navigate to the brand first preorder marketplace, deprecated now that preorder marketplace is product first
         * @deprecated
         */
        NavigationType["APPAREL_BRAND"] = "APPAREL_BRAND";
        /**
         * navigate to a sale collection product page
         */
        NavigationType["SALES"] = "SALES";
        /**
         * navigate to a special page, e.g. Brands A - Z page, Trending on Faire page
         */
        NavigationType["SPECIAL"] = "SPECIAL";
        /**
         * navigate to the product first Preorder Marketplace, with a pre-selected category
         * @deprecated
         */
        NavigationType["APPAREL_PRODUCT"] = "APPAREL_PRODUCT";
        /**
         * navigate to a carousel list rendering of the provided sublinks
         */
        NavigationType["CAROUSEL_LIST"] = "CAROUSEL_LIST";
        /**
         * navigation to a view that allows users to explore preorders across combined seasons, to
         * explore the breadth of products during fashion week across C1/C2s.
         * Figma: https:www.figma.com/file/AeF21BMh8kVZAT1n58GpfQ/FFWv2-%E2%80%93--Retailer-Handoff?node-id=2519%3A225927
         */
        NavigationType["FASHION_EXPLORATION"] = "FASHION_EXPLORATION";
        /**
         * navigation is not active for interaction
         */
        NavigationType["INACTIVE"] = "INACTIVE";
        /**
         * navigation to a hub page
         */
        NavigationType["HUB"] = "HUB";
    })(NavigationType = INavigationLink.NavigationType || (INavigationLink.NavigationType = {}));
    let IMakerProductsSort;
    (function (IMakerProductsSort) {
        /**
         * Return an instance of IMakerProductsSort with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IMakerProductsSort.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(IMakerProductsSort = INavigationLink.IMakerProductsSort || (INavigationLink.IMakerProductsSort = {}));
    let IMakerSort;
    (function (IMakerSort) {
        /**
         * Return an instance of IMakerSort with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IMakerSort.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(IMakerSort = INavigationLink.IMakerSort || (INavigationLink.IMakerSort = {}));
    let IGroupsToColumn;
    (function (IGroupsToColumn) {
        /**
         * Return an instance of IGroupsToColumn with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IGroupsToColumn.build = (partial) => (Object.assign({ group_names: [] }, (partial !== null && partial !== void 0 ? partial : {})));
    })(IGroupsToColumn = INavigationLink.IGroupsToColumn || (INavigationLink.IGroupsToColumn = {}));
    let StyleGroup;
    (function (StyleGroup) {
        StyleGroup["STYLE_GROUP_UNKNOWN"] = "STYLE_GROUP_UNKNOWN";
        /**
         * "New Product" "New Brand" etc. are a group of links with their own style (e.g. bolded)
         */
        StyleGroup["HARDCODED_CATEGORY"] = "HARDCODED_CATEGORY";
        /**
         * Preorder season year (Summer 2021) or real categories (e.g. Bath)
         */
        StyleGroup["LISTED_CATEGORY"] = "LISTED_CATEGORY";
        /**
         * Show "Shop All" as a button for apparel C1s
         */
        StyleGroup["SHOP_ALL"] = "SHOP_ALL";
        /**
         * Tile for the Carousel_V2 NavigationLinks
         */
        StyleGroup["TALL_TILE"] = "TALL_TILE";
        /**
         * Tile for the original Trending Collection NavigationLinks
         */
        StyleGroup["WIDE_TILE"] = "WIDE_TILE";
        /**
         * A standalone divider to separate sections, mainly for mobile web
         */
        StyleGroup["DIVIDER"] = "DIVIDER";
        /**
         * Indicator that the navigation link should be hidden from all clients' views
         * Linking to and navigating to this node its sublinks will still be possible
         * Specifically created to accommodate navigations that should be hidden from regular category menus
         * but remain accessible through specialized routes
         */
        StyleGroup["INVISIBLE"] = "INVISIBLE";
        /**
         * Indicator that the navigation link is hidden from part of the clients due to ongoing experiments
         * Clients should still call /record-category-node-visibility even if the navigation link is hidden
         */
        StyleGroup["INVISIBLE_FOR_ASSIGNMENT"] = "INVISIBLE_FOR_ASSIGNMENT";
        /**
         * Only used by desktop-web.
         * All sublinks are shown in a single column under parent.
         * https:www.figma.com/design/4yygDLbVtWTIIYk9JT2QD6/Navigation-to-new-browse-surfaces?node-id=8980-305988&t=f4tWunLPy0TjSyvw-0
         */
        StyleGroup["LIST_COLUMN"] = "LIST_COLUMN";
    })(StyleGroup = INavigationLink.StyleGroup || (INavigationLink.StyleGroup = {}));
    let Customization;
    (function (Customization) {
        Customization["CUSTOMIZATION_UNKNOWN"] = "CUSTOMIZATION_UNKNOWN";
        /**
         * The right image under level 1 navigation link "New"（"New" tab in category navigation)
         * is customized and different from other right images
         */
        Customization["NEW_GROUP_RIGHT_IMAGE"] = "NEW_GROUP_RIGHT_IMAGE";
        /**
         * Highlight with events theme icon may apply to certain link during an Faire event.
         */
        Customization["EVENTS_THEME_ICON"] = "EVENTS_THEME_ICON";
        /**
         * Place header and footer text above/below the image caption
         */
        Customization["GIFT_GUIDE_THEME"] = "GIFT_GUIDE_THEME";
        /**
         * FFW 2022 pre-event entry point on mobile web
         */
        Customization["PRE_EVENT_ENTRY_FFW_2022"] = "PRE_EVENT_ENTRY_FFW_2022";
        /**
         * Fashion week 2022 will have a customized dropdown
         */
        Customization["FASHION_WEEK_2022_CUSTOMIZED_DROPDOWN"] = "FASHION_WEEK_2022_CUSTOMIZED_DROPDOWN";
        /**
         * Fashion week 2022 will have a customized right image
         */
        Customization["FASHION_WEEK_2022_DESKTOP_RIGHT_IMAGE"] = "FASHION_WEEK_2022_DESKTOP_RIGHT_IMAGE";
        /**
         * Fashion week 2022 static entry point on mobile web
         */
        Customization["FASHION_WEEK_2022_MOBILE_WEB_ENTRY_POINT"] = "FASHION_WEEK_2022_MOBILE_WEB_ENTRY_POINT";
        /**
         * Fashion week 2022 L2 links on mobile web background customization
         */
        Customization["FASHION_WEEK_2022_MOBILE_WEB_BACKGROUND"] = "FASHION_WEEK_2022_MOBILE_WEB_BACKGROUND";
        /**
         * Fashion week 2022 twinkle shows on the left side of navigation link
         */
        Customization["FASHION_WEEK_2022_TWINKLE_LEFT"] = "FASHION_WEEK_2022_TWINKLE_LEFT";
        /**
         * Fashion week 2022 twinkle shows on the right side of navigation link
         */
        Customization["FASHION_WEEK_2022_TWINKLE_RIGHT"] = "FASHION_WEEK_2022_TWINKLE_RIGHT";
        /**
         * New Tag next to Plus Size to highlight that the category is newly introduced
         * @deprecated
         */
        Customization["PLUS_SIZE_NEW"] = "PLUS_SIZE_NEW";
        /**
         * Preserve the order of the link as they appear in the list
         */
        Customization["PRESERVE_ORDER"] = "PRESERVE_ORDER";
        /**
         * For FE to augment col width when this is present in a C2
         */
        Customization["AUGMENT_COLUMN_WIDTHS"] = "AUGMENT_COLUMN_WIDTHS";
    })(Customization = INavigationLink.Customization || (INavigationLink.Customization = {}));
    let IRequestArguments;
    (function (IRequestArguments) {
        let IQueryParamsValues;
        (function (IQueryParamsValues) {
            /**
             * Return an instance of IQueryParamsValues with the provided fields. Any field not
             * listed will be populated with an empty value (an empty array,
             * or undefined, whichever is valid for the type of the value.)
             */
            IQueryParamsValues.build = (partial) => (Object.assign({ query_params_values: [] }, (partial !== null && partial !== void 0 ? partial : {})));
        })(IQueryParamsValues = IRequestArguments.IQueryParamsValues || (IRequestArguments.IQueryParamsValues = {}));
        /**
         * Return an instance of IRequestArguments with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IRequestArguments.build = (partial) => (Object.assign({ query_params: {} }, (partial !== null && partial !== void 0 ? partial : {})));
    })(IRequestArguments = INavigationLink.IRequestArguments || (INavigationLink.IRequestArguments = {}));
    /**
     * Return an instance of INavigationLink with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    INavigationLink.build = (partial) => (Object.assign({ sublinks: [], image_captions: [], groups_to_columns: [], preselected_filter_keys: [], customizations: [], query_params: {}, redirect_deep_link_paths: [] }, (partial !== null && partial !== void 0 ? partial : {})));
})(INavigationLink || (INavigationLink = {}));
